import Swiper from 'swiper';
import {
    Navigation,
} from 'swiper/modules';


(function() {

    var uniSlider = document.querySelectorAll(".uniSlider .swiper");
    var uniSliderCollectInstances = [];

    // uniSlider
    if (uniSlider.length > 0) {
        // group init
        uniSlider.forEach(function (s, i) {

            let prev = s.parentElement.querySelector(".uniSliderActions__btn--prev");
            let next = s.parentElement.querySelector(".uniSliderActions__btn--next");


            let sldr = new Swiper(s, {
                modules: [Navigation],
                slidesPerView: "auto",
                loop: true,
                autoplay: true,
                speed: 1e3,
                grabCursor: true,
                direction: "horizontal",
                navigation: {
                    nextEl: next,
                    prevEl: prev
                },
                on: {
                    slideChange: function (swp) {
                        // fix transform pic to inline svg inside slides
                        // transformSvgPicToInlineSvg(swp)
                    },
                },
            });

            uniSliderCollectInstances.push(sldr)
        });
    }

})();
